// Module
var code = `<div class="comparison-editions__select" data-comparison-editions-select [class.comparison-editions__select--single]="mode === 'single'">
    <div class="comparison-editions__select-control comparison-editions__select-control--intra-block"
         [class.comparison-editions__select-control--open]="isOpen"
         (click)="toggleDropdown(\$event)">
        <div class="comparison-editions__select-panel" [class.comparison-editions__select-panel--single]="mode === 'single'">
            <div class="comparison-editions__select-panel-left">
                <!-- Для single mode показываем название выбранного элемента -->
                @if (mode === 'single' && selectedItem) {
                    <span class="comparison-editions__select-counter comparison-editions__select-counter--single">
                        {{ selectedItem.name }}
                    </span>
                }

                <!-- Для multiple mode показываем количество выбранных -->
                @if (mode === 'multiple' && selectedItems?.length > 0) {
                    <span class="comparison-editions__select-counter">
                        {{ selectedItems?.length }}
                    </span>
                }
            </div>
            <div class="comparison-editions__select-arrow" [class.comparison-editions__select-arrow--open]="isOpen">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.75 4.75L4.75 0.75L0.75 4.75" stroke="#1D1C1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>

    @if (isOpen) {
        <div class="comparison-editions__select-dropdown comparison-editions__select-dropdown--intra-block">
            <div class="comparison-editions__select-options-list" [class.comparison-editions__select-options-list--single]="mode === 'single'">
                <div class="mb-5">
                    @for (unit of units; track unit.id) {
                        <!-- Multiple mode с чекбоксами -->
                        @if (mode === 'multiple') {
                            <div class="comparison-editions__select-option">
                                <label class="comparison-editions__select-option-label">
                                    <input
                                            class="comparison-editions__option-custom-input"
                                            type="checkbox"
                                            [checked]="isSelected(unit)"
                                            (change)="toggleItem(unit, \$event)"
                                            [disabled]="hasOneCheckboxChecked && isSelected(unit)"
                                    >
                                    <span class="comparison-editions__select-option-text">{{ unit.name }}</span>
                                </label>
                            </div>
                        }

                        <!-- Single mode без чекбоксов -->
                        @if (mode === 'single') {
                            <div
                                    class="comparison-editions__select-option-single"
                                    [class.comparison-editions__select-option-single--selected]="isSelected(unit)"
                                    [class.comparison-editions__select-option-single--disabled]="hasOneCheckboxChecked && isSelected(unit)"
                                    (click)="selectItem(unit)">
                                <span class="comparison-editions__select-option-single-text">{{ unit.name }}</span>
                            </div>
                        }
                    }
                </div>

                <!-- Кнопка "Применить" только для multiple mode -->
                @if (mode === 'multiple') {
                    <h4 (click)="onApplyEditions()">Применить</h4>
                }
            </div>
        </div>
    }
</div>
`;
// Exports
export default code;